import React from 'react';

import { observer, inject } from "mobx-react";
import { SelectInput, Input, Table, InputValidation, SingleSwitch,Notification  } from '@sogei/react-web-components-catalog'

//import { breadcrumbCompilazione, breadcrumbDatiUtente } from '../assets/breadcrumb';
import i18next from 'i18next';
//import { BackgroundIconCard, Card } from './commons/cardApp';
import { AppButton } from '../commons/button';
//import { HelpConstestuale } from './helpContestuale';
import { Formik } from 'formik';
import * as Yup from 'yup'
import { overlay, scrollToTop } from '../commons/uiUtils';
import { regExpOnlyNumbers, regExpIBAN , regExpCodiceFiscalePNF} from '../../assets/utils/regexp';
//import { ROUTE_COMPILAZIONE } from '../assets/frontendRouting';
//import { isCompilazioneSemplificataUfficio, isCompilazioneSemplificataUtenteNonTelematico } from '../assets/tipologiche/tipoCompilazione';


@inject("rootStore")
@observer
class DatiUtente extends React.Component {

  constructor(props) {
        super(props);
        this.initialErroValues = {
          errorsCodiceFiscalePU: undefined,
          errorsCodiceFiscaleStudio: undefined,
          errorsCodiceIBAN: undefined
        }
        this.state = {
          ...this.initialErroValues,
          comuni: [],
          downloadPagamentoIntegrativoEffettuato: false
        }
        this.tipologicaStore = props.rootStore.tipologicaStore;
        this.compilazioneStore = props.rootStore.compilazioneStore;
        this.ricevuteStore = props.rootStore.ricevuteStore;
        this.qualificheStore = props.rootStore.qualificheStore;
        this.tipoPratica = this.qualificheStore.tipoPratica
        this.utenteStore = props.rootStore.utenteStore;
        this.onSubmit = this.onSubmit.bind(this);
        this.clean = this.clean.bind(this);
        this.onClickAggiungiConvenzioneBancaria = this.onClickAggiungiConvenzioneBancaria.bind(this);
        this.onClickModificaConvenzioneBancaria = this.onClickModificaConvenzioneBancaria.bind(this);
        this.onClickRimuoviConvenzioneBancaria = this.onClickRimuoviConvenzioneBancaria.bind(this);
        this.validationSchema =  Yup.object({
          tipoPU: Yup.string().required(i18next.t("VALIDATION_TIPO_PUBBLICO_UFFICIALE")),
          //codUfficioEntrate: Yup.mixed().required(i18next.t("VALIDATION_UFFICIO_ENTRATE")),
          codiceFiscalePU: Yup.mixed().required(i18next.t("VALIDATION_CODICE_FISCALE_PUBBLICO_UFFICIALE")),
          denominazionePU: Yup.mixed().required(i18next.t("VALIDATION_DENOMINAZIONE_PUBBLICO_UFFICIALE")),
          codiceComune: Yup.mixed().required(i18next.t("VALIDATION_COMUNE")),
          convenzioneBancaria_codiceFiscale: Yup.mixed().required(i18next.t("VALIDATION_CODICE_FISCALE_PUBBLICO_UFFICIALE")) ,
          convenzioneBancaria_codiceFiscaleStudio: Yup.mixed().test(i18next.t("VALIDATION_CODICE_FISCALE_ENTE_INVALID"),i18next.t("VALIDATION_CODICE_FISCALE_ENTE_INVALID"),(value)=> {
            if(!value) {
              return true;
            }
            return regExpCodiceFiscalePNF(value);
          }),          
          convenzioneBancaria_codiceIBAN: Yup.mixed().required(i18next.t("VALIDATION_CODICE_IBAN")).test(i18next.t("VALIDATION_CODICE_IBAN_INVALID"),i18next.t("VALIDATION_CODICE_IBAN_INVALID"),(value)=> {
            if(!value) {
              return true;
            }
            return regExpIBAN(value);
          }),          
          
          })
      
        
        this.loadComuni = this.loadComuni.bind(this);
    }  
    

    componentDidMount() { 
      //this.tipologicaStore.fetchUfficioEntrate("A");
     
      this.tipologicaStore.fetchTipoPubblicoUfficiale();
      this.tipologicaStore.fetchProvince();
      this.utenteStore.readDatiUtente( (utente) => {
        try {
          this.loadComuni(utente.provincia);
        } catch (error) {
        }
      });
    }
    
    onChange(props){
      props.values.abilitaAltriImporti = !props.values.abilitaAltriImporti;
      console.log(props.values.abilitaAltriImporti)

    }
    componentWillUnmount() { }

    onClickAggiungiConvenzioneBancaria(formikProps) {
      // validazione custom eseguita solo quando ci sono delle subvalidazioni da fare prima della submit finale
      // STEP -1 reset
      this.setState(this.initialErroValues)
      // STEP -2 validazione
      let localState = {}
      let convenzioniBancarie = formikProps.values.convenzioniBancarie;
      let codiceFiscale = formikProps.values.convenzioneBancaria_codiceFiscale
      let codiceFiscaleStudio = formikProps.values.convenzioneBancaria_codiceFiscaleStudio
      let codiceIBAN = formikProps.values.convenzioneBancaria_codiceIBAN
      let editIndex = formikProps.values.convenzioneBancaria_editIndex
      let error=false;
      if(!codiceFiscale) {
        error=true;
        localState.errorsCodiceFiscalePU = i18next.t("VALIDATION_CODICE_FISCALE_PUBBLICO_UFFICIALE");
      }

      if(codiceFiscaleStudio){
        // campo non obbligatorio, ma se inserito viene validato il formato
        if(codiceFiscaleStudio.length !== 11 || !regExpOnlyNumbers(codiceFiscaleStudio)) {
          error=true;
          localState.errorsCodiceFiscalePU =i18next.t("VALIDATION_CODICE_FISCALE_ENTE_INVALID");
        }
      }

      if(!codiceIBAN) {
        error=true;
        localState.errorsCodiceIBAN = i18next.t("VALIDATION_CODICE_IBAN");
      } else if (codiceIBAN.length !== 27) {
        error=true;
        localState.errorsCodiceIBAN = i18next.t("VALIDATION_CODICE_IBAN_INVALID");
      }


      // verifica di univocita' per codice IBAN
      if(editIndex !== undefined) {
        let index = convenzioniBancarie.findIndex(elem => elem.codiceIBAN == codiceIBAN);
        if(index !== -1 && index != editIndex) {
          error=true;
          localState.errorsCodiceIBAN = i18next.t("VALIDATION_CODICE_IBAN_EXISTS");
        }
      } else {
        if(convenzioniBancarie.filter(elem => elem.codiceIBAN == codiceIBAN).length > 0) {
          error=true;
          localState.errorsCodiceIBAN = i18next.t("VALIDATION_CODICE_IBAN_EXISTS");
        }
      }

      if(error) {
        this.setState(localState)
        scrollToTop("errors_convenzioni_bancarie");
        return;
      }

      if(editIndex !== undefined) {
        convenzioniBancarie[editIndex].codiceFiscale = codiceFiscale
        convenzioniBancarie[editIndex].codiceFiscaleStudio = codiceFiscaleStudio
        convenzioniBancarie[editIndex].codiceIBAN = codiceIBAN
      } else {
        convenzioniBancarie.push({
          codiceFiscale,
          codiceFiscaleStudio,
          codiceIBAN
        })
      }
      formikProps.setFieldValue('convenzioniBancarie',convenzioniBancarie);
      formikProps.setFieldValue('convenzioneBancaria_codiceFiscale','');
      formikProps.setFieldValue('convenzioneBancaria_codiceFiscaleStudio','');
      formikProps.setFieldValue('convenzioneBancaria_codiceIBAN','');
      formikProps.setFieldValue('convenzioneBancaria_editIndex',undefined);
    }

    onClickModificaConvenzioneBancaria(formikProps, item,index) {
      formikProps.setFieldValue("convenzioneBancaria_codiceFiscale",item.codiceFiscale);
      formikProps.setFieldValue("convenzioneBancaria_codiceFiscaleStudio",item.codiceFiscaleStudio);
      formikProps.setFieldValue("convenzioneBancaria_codiceIBAN",item.codiceIBAN);
      formikProps.setFieldValue("convenzioneBancaria_editIndex",index);
    }

    onClickRimuoviConvenzioneBancaria(formikProps,index) {
      let list = formikProps.values.convenzioniBancarie;
      let item = list[index];
      let  text = i18next.t("MESSAGE_UTENTE_CONFERMA_RIMOZIONE_CONV_BANCARIA", {
        codiceIBAN: item.codiceIBAN
      });
      if(confirm(text)) {
       list.splice(index,1);
       formikProps.setFieldValue("convenzioniBancarie",list);
       formikProps.setFieldValue("convenzioneBancaria_editIndex",undefined);
      }
    }

    onClickAnnullaModificaConvenzioneBancaria(formikProps) {
      formikProps.setFieldValue("convenzioneBancaria_codiceFiscale",'');
      formikProps.setFieldValue("convenzioneBancaria_codiceFiscaleStudio",'');
      formikProps.setFieldValue("convenzioneBancaria_codiceIBAN",'')
      formikProps.setFieldValue("convenzioneBancaria_editIndex",undefined);
    }

    onSubmit(values,actions) {
    
     let jsonServizioPagamentoIntegrativo = {
      chiaveFile:{
        tipoPU: values.tipoPU,
        codiceFiscalePU: values.codiceFiscalePU,
        denominazionePU: values.denominazionePU,
        codiceComune: values.codiceComune.split("#@#")[0],
        cap: values.cap,
        indirizzo: values.indirizzo
      },
      pagamentoTelematico:{
        codiceIBAN: values.convenzioneBancaria_codiceIBAN,
        codiceFiscaleStudio: values.convenzioneBancaria_codiceFiscaleStudio,
        codiceFiscale: values.convenzioneBancaria_codiceFiscale
      },
      integrazioneDebito:{
        codiceAttoRichiesta: values.codiceAtto,
        importoDebito: values.importo.replace(',','').replace('.',''),
        importoNotifica: values.importoNotifica?values.importoNotifica.replace(',','').replace('.',''): undefined,
        importoSanzioni: values.importoSanzioni? values.importoSanzioni.replace(',','').replace('.',''): undefined,
        importoInteressi: values.importoInteressi? values.importoInteressi.replace(',','').replace('.','') : undefined
      }
     }
     this.setState({downloadPagamentoIntegrativoEffettuato:false})
      this.ricevuteStore.downloadPagamentoIntegrativo(jsonServizioPagamentoIntegrativo,response =>{
        if(response.success) {
          this.setState({downloadPagamentoIntegrativoEffettuato:true})
        }
      })
      
      
      let json = {
        tipoPU: values.tipoPU,
        //codUfficioEntrate: values.codUfficioEntrate,
        codiceFiscalePU: values.codiceFiscalePU,
        denominazionePU: values.denominazionePU,
        provincia: values.provincia,
        codiceComune: values.codiceComune,
        cap: values.cap,
        indirizzo: values.indirizzo,
        convenzioniBancarie: values.convenzioniBancarie.length > 0 ? values.convenzioniBancarie : undefined,
      }
      this.utenteStore.saveDatiUtente(json,(response) =>{
        actions.setSubmitting(false);
        if(response.success) {
          //this.props.rootStore.routingStore.push(`${process.env.CONTEXT_PATH}${ROUTE_COMPILAZIONE}`); //Modificare
        }
      });
    }

    clean(formikProps){
      this.utenteStore.cleanUtente();
      formikProps.resetForm();
      formikProps.setFieldValue('convenzioniBancarie',[]); // essendo un tipo custom rispetto ai valori di una form, devo specificarlo a manella
      this.setState(this.initialErroValues);
    }

    loadComuni(provincia) {
      this.tipologicaStore.fetchComuni(provincia).then( (comuni) => {
        this.setState({comuni})
      });
    }

    render() {   
       
      //const isCompilazioneSemplificataUfficio = true; //TODO: va modificato post collaudo integrando la funzione
      //const isCompilazioneSemplificataUtenteNonTelematico= true; //come riga 200
      const listaTipoPubblicoUfficiale = this.tipologicaStore.tipoPubblicoUfficiale;
      const listaUfficioEntrate = this.tipologicaStore.ufficioEntrate;
      const listaProvince = this.tipologicaStore.province;
      const listaComuni = this.state.comuni;
      const utente = {...this.utenteStore.utente};

      const validation = (touched, errors) => {
          if (
              (touched.tipoPU && errors.tipoPU)
             //|| (touched.codUfficioEntrate && errors.codUfficioEntrate)
             || (touched.codiceFiscalePU && errors.codiceFiscalePU)
             || (touched.denominazionePU && errors.denominazionePU)
             || (touched.provincia && errors.provincia)
             || (touched.codiceComune && errors.codiceComune)
             || (touched.cap && errors.cap)
             || (touched.indirizzo && errors.indirizzo)
             || (touched.convenzioneBancaria_codiceIBAN && errors.convenzioneBancaria_codiceIBAN)
             || (touched.convenzioneBancaria_codiceFiscale && errors.convenzioneBancaria_codiceFiscale)
             || (touched.convenzioneBancaria_codiceFiscaleStudio && errors.convenzioneBancaria_codiceFiscaleStudio)
             || (touched.convenzioniBancarie && errors.convenzioniBancarie)

          ) {
            
              return <>
                <InputValidation show={touched.tipoPU && errors.tipoPU} error={errors.tipoPU} />
                {/*<InputValidation show={touched.codUfficioEntrate && errors.codUfficioEntrate} error={errors.codUfficioEntrate} />*/}
                <InputValidation show={touched.codiceFiscalePU && errors.codiceFiscalePU} error={errors.codiceFiscalePU} />
                <InputValidation show={touched.denominazionePU && errors.denominazionePU} error={errors.denominazionePU} />
                <InputValidation show={touched.provincia && errors.provincia} error={errors.provincia} />
                <InputValidation show={touched.codiceComune && errors.codiceComune} error={errors.codiceComune} />
                <InputValidation show={touched.cap && errors.cap} error={errors.cap} />
                <InputValidation show={touched.indirizzo && errors.indirizzo} error={errors.indirizzo} />
                <InputValidation show={touched.convenzioneBancaria_codiceIBAN && errors.convenzioneBancaria_codiceIBAN} error={errors.convenzioneBancaria_codiceIBAN}></InputValidation>
                <InputValidation show={touched.convenzioneBancaria_codiceFiscale && errors.convenzioneBancaria_codiceFiscale} error={errors.convenzioneBancaria_codiceFiscale}></InputValidation>
                <InputValidation show={touched.convenzioneBancaria_codiceFiscaleStudio && errors.convenzioneBancaria_codiceFiscaleStudio} error={errors.convenzioneBancaria_codiceFiscaleStudio}></InputValidation>
                <InputValidation show={touched.convenzioniBancarie && errors.convenzioniBancarie} error={errors.convenzioniBancarie} />
                
              </>
          }
          return null;
      }

      
      const customLocalValidation = (touched) => {
        if (
            (this.state.errorsCodiceFiscalePU !== undefined)
            || (this.state.errorsCodiceFiscaleStudio !== undefined)
            || (this.state.errorsCodiceIBAN !== undefined)

        ) {
            return <>
              <InputValidation show={this.state.errorsCodiceFiscalePU !== undefined} error={this.state.errorsCodiceFiscalePU} />
              <InputValidation show={this.state.errorsCodiceFiscaleStudio !== undefined} error={this.state.errorsCodiceFiscaleStudio} />
              <InputValidation show={this.state.errorsCodiceIBAN !== undefined} error={this.state.errorsCodiceIBAN} />
              
            </>
        }
        return null;
    }
      
      const tableHead = (
          <tr>
              <th>{i18next.t("CODICE_FISCALE_PUBBLICO_UFFICIALE")}</th>
              <th>{i18next.t("CODICE_FISCALE_ENTE")}</th>
              <th>{i18next.t("CODICE_IBAN")}</th>
              <th><span className='sr-only'>{i18next.t("TABLE_AZIONI")}</span></th>
          </tr>
      )

      const tableBody = (props) => props.values.convenzioniBancarie == 0 ? (<tr><td colSpan="4" key={props.values.convenzioniBancarie.length}><span>{i18next.t("TABLE_CONVENZIONI_BANCARIE_NO_RESULTS")}</span></td></tr>)
        : props.values.convenzioniBancarie.map((item,index) => { return (<>
            <tr>
                <td><span>{item.codiceFiscale}</span></td>
                <td><span>{item.codiceFiscaleStudio}</span></td>
                <td><span>{item.codiceIBAN}</span></td>
                <td className="text-right text-nowrap">
                    <AppButton titleKey="Seleziona" spanSrOnly="BUTTON_MODIFICA_CONVENZIONE_BANCARIA" customClass="btn-xs mr-2"  onClick={() => this.onClickModificaConvenzioneBancaria(props, item, index)}></AppButton>
                    <AppButton color="red" titleKey="" spanSrOnly="BUTTON_ELIMINA_CONVENZIONE_BANCARIA" customClass="btn-xs" iconCenter="fas fa-trash-alt" onClick={() => this.onClickRimuoviConvenzioneBancaria(props, index)}></AppButton>
                </td>
            </tr>
        </>)
      })


        return (
          <div className="container-fluid pr-3 pl-3 pb-3">
          
            <h3><i className="fas fa-euro-sign fa-title mr-2"/> {i18next.t("PAGAMENTO_INTEGRATIVO")}</h3>
                        <Formik 
              initialValues={{
                tipoPU: utente.tipoPU ? utente.tipoPU : '',
                //codUfficioEntrate: utente.codUfficioEntrate ? utente.codUfficioEntrate : '',
                importo: this.ricevuteStore.datiPagamentoIntegrativoPrecompilato.importoDebito? this.ricevuteStore.datiPagamentoIntegrativoPrecompilato.importoDebito : '',
                codiceAtto: this.ricevuteStore.datiPagamentoIntegrativoPrecompilato.codiceAtto? this.ricevuteStore.datiPagamentoIntegrativoPrecompilato.codiceAtto : '',
                codiceFiscalePU: utente.codiceFiscalePU ? utente.codiceFiscalePU : '',
                denominazionePU: utente.denominazionePU ? utente.denominazionePU : '',
                provincia: utente.provincia ? utente.provincia : '',
                codiceComune: utente.codiceComune ? utente.codiceComune : '',
                cap: utente.cap ? utente.cap : '',
                indirizzo: utente.indirizzo ? utente.indirizzo : '',
                convenzioniBancarie: utente.convenzioniBancarie ? utente.convenzioniBancarie : [],
                convenzioneBancaria_codiceFiscale: '',
                convenzioneBancaria_codiceFiscaleStudio: '',
                convenzioneBancaria_codiceIBAN: '',
                abilitaAltriImporti: false,
                convenzioneBancaria_editIndex: undefined
              }}
              validationSchema={this.validationSchema}
              enableReinitialize={true}
              onReset={()=>{
                console.log("reset")
              }}
              onSubmit={(values, actions) => {
                scrollToTop();
                this.onSubmit(values,actions);
              }}>
                {props => (
                  <>
                    {props.isSubmitting ? overlay() : null}
                    <div className='my-4'>
                    <AppButton 
                      color="none"
                      isLinkStyle={true}
                      iconLeft="fas fa-long-arrow-alt-left mr-2"
                      titleKey="BUTTON_TORNA_ELENCO_AVVISI"
                      onClick={() => this.ricevuteStore.backToSecondoLivello(this.tipoPratica)}
                    />
                  </div>
                    <div className="my-2">
                      {validation(props.touched, props.errors)}
                    </div>
                    <form onSubmit={props.handleSubmit}>
                   
                    {
                        this.state.downloadPagamentoIntegrativoEffettuato ?
                        <Notification title='Pagamento Integrativo scaricato con successo' subtitle={'Per integrare il debito si firmi digitalmente il pagamento integrativo prodotto e si invii il file firmato nella sezione "Trasmissione" di questa applicazione '} notificationType={'success'}/>                        
                        // <Messages successMessages={[{text:'Iscrizione completata con successo con identificativo: '+descServizioSelezionato}]} infoMessages={[]} warningMessages={[]} dangerMessages={[]}></Messages> 
                        : null 
                    }

                    <div className='row'>
                      <div className='col-sm-12 col-md-4 col-xl-4'>
                              <Input
                                id="codiceAtto"
                                name="codiceAtto"
                                value={props.values.codiceAtto}
                                type="text"
                                dimension="lg"
                                label={<b>{i18next.t("CODICE_ATTO")}</b>}
                                error={props.touched.codiceAtto && props.errors.codiceAtto}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  maxLength: "16",
                                  isMandatory: true
                                }}
                              />
                      </div>
                       <div className='col-sm-12 col-md-4 col-xl-4'>
                              <Input
                                id="importo"
                                name="importo"
                                value={props.values.importo}
                                type="text"
                                dimension="lg"
                                label={<b>{i18next.t("IMPORTO")}</b>}
                                error={props.touched.importo && props.errors.importo}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  maxLength: "16",
                                  isMandatory: true
                                }}
                              />
                      </div>
                      <div className='col-sm-12 col-md-4 col-xl-4 p-4'>
                      <SingleSwitch
                            id="abilitaAltriImporti"
                            name="abilitaAltriImporti"
                            label={i18next.t("ABILITA_INSERIMENTO_ALTRI_IMPORTI")}
                            dimension="sm"
                            event={{onChange:  props.handleChange}}
                            inputClass={[]}
                            labelClass={[]}
                            extraProps={{ visible: true , checked: props.values.abilitaAltriImporti }}
                      />
                      </div>
                    </div>
                    <div className='row'>
                    <div className='col-sm-12 col-md-4 col-xl-4'> 
                              <Input
                                id="importoNotifica"
                                name="importoNotifica"
                                value={props.values.importoNotifica}
                                type="text"
                                dimension="lg"
                                label={i18next.t("IMPORTO_NOTIFICA")}
                                error={props.touched.importoNotifica && props.errors.importoNotifica}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  maxLength: "16",
                                  isMandatory: false,
                                  disabled: !props.values.abilitaAltriImporti
                                }}
                              />
                      </div>
                      <div className='col-sm-12 col-md-4 col-xl-4'>
                              <Input
                                id="importoInteressi"
                                name="importoInteressi"
                                value={props.values.importoInteressi}
                                type="text"
                                dimension="lg"
                                label={i18next.t("IMPORTO_INTERESSI")}
                                error={props.touched.importoInteressi && props.errors.importoInteressi}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  maxLength: "16",
                                  isMandatory: false,
                                  disabled: !props.values.abilitaAltriImporti
                                }}
                              />
                      </div>
                      <div className='col-sm-12 col-md-4 col-xl-4'>
                              <Input
                                id="importoSanzioni"
                                name="importoSanzioni"
                                value={props.values.importoSanzioni}
                                type="text"
                                dimension="lg"
                                label={i18next.t("IMPORTO_SANZIONI")}
                                error={props.touched.importoSanzioni && props.errors.importoSanzioni}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  maxLength: "16",
                                  isMandatory: false,
                                  disabled: !props.values.abilitaAltriImporti
                                }}
                              />
                      </div>
                    </div>
                    <h4><i className="fas fa-users fa-title mr-2" />{i18next.t("DATI_UTENTE")}</h4>
                    <p>Si inseriscano i dati dell'utente nei campi sottostanti."</p>

                        
                        <div className='row'>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                            <SelectInput
                                id="tipoPU"
                                name="tipoPU"
                                value={props.values.tipoPU}
                                dimension="lg"
                                label={<b>{i18next.t("TIPO_PUBBLICO_UFFICIALE")}</b>}
                                firstEmptyOption={true}
                                optionList={listaTipoPubblicoUfficiale}
                                error={props.touched.tipoPU && props.errors.tipoPU}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  isMandatory: true
                                }}
                            ></SelectInput>
                          </div>
                         {/* <div className='col-sm-12 col-md-4 col-xl-4'>
                            <SelectInput
                                id="codUfficioEntrate"
                                name="codUfficioEntrate"
                                value={props.values.codUfficioEntrate}
                                dimension="lg"
                                label={<b>{i18next.t("UFFICIO_ENTRATE")}</b>}
                                firstEmptyOption={true}
                                optionList={listaUfficioEntrate}
                                error={props.touched.codUfficioEntrate && props.errors.codUfficioEntrate}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  isMandatory: true
                                }}
                            ></SelectInput>
                          </div>*/}
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                            <Input
                              id="codiceFiscalePU"
                              name="codiceFiscalePU"
                              value={props.values.codiceFiscalePU}
                              type="text"
                              dimension="lg"
                              label={<b>{i18next.t("CODICE_FISCALE_PUBBLICO_UFFICIALE")}</b>}
                              error={props.touched.codiceFiscalePU && props.errors.codiceFiscalePU}
                              inputClass={[]}
                              labelClass={[]}
                              event={{ onChange: props.handleChange }}
                              extraProps={{
                                maxLength: "16",
                                isMandatory: true
                              }}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                            <Input
                              id="denominazionePU"
                              name="denominazionePU"
                              value={props.values.denominazionePU}
                              type="text"
                              dimension="lg"
                              label={<b>{i18next.t("DENOMINAZIONE_PUBBLICO_UFFICIALE")}</b>}
                              error={props.touched.denominazionePU && props.errors.denominazionePU}
                              inputClass={[]}
                              labelClass={[]}
                              event={{ onChange: props.handleChange }}
                              extraProps={{
                                maxLength:50,
                                isMandatory: true
                              }}
                            />
                          </div>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                            <SelectInput
                                id="provincia"
                                name="provincia"
                                value={props.values.provincia}
                                dimension="lg"
                                label={<b>{i18next.t("PROVINCIA")}</b>}
                                firstEmptyOption={true}
                                optionList={listaProvince}
                                error={props.touched.provincia && props.errors.provincia}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: (event) => {
                                  props.handleChange(event);
                                  this.loadComuni(event.target.value);
                                } }}
                                extraProps={{}}
                            ></SelectInput>
                          </div>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                            <SelectInput
                                id="codiceComune"
                                name="codiceComune"
                                value={props.values.codiceComune}
                                dimension="lg"
                                label={<b>{i18next.t("COMUNE")}</b>}
                                firstEmptyOption={true}
                                optionList={listaComuni}
                                error={props.touched.codiceComune && props.errors.codiceComune}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  isMandatory: true
                                }}
                            ></SelectInput>
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                              <Input
                                id="cap"
                                name="cap"
                                value={props.values.cap}
                                type="text"
                                dimension="lg"
                                label={i18next.t("CAP")}
                                error={props.touched.cap && props.errors.cap}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{ maxLength: "5" }}
                              />
                          </div>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                              <Input
                                id="indirizzo"
                                name="indirizzo"
                                value={props.values.indirizzo}
                                type="text"
                                dimension="lg"
                                label={i18next.t("INDIRIZZO")}
                                error={props.touched.indirizzo && props.errors.indirizzo}
                                inputClass={[]} 
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{
                                  maxLength: "50" }}
                              />
                          </div>
                          
                        </div>
                      
                        <h4><i className="fas fa-money-check fa-title mr-2"/>{i18next.t("CONVENZIONE_BANCARIA")}</h4>
                        <div className="my-2" id="errors_convenzioni_bancarie">
                          {customLocalValidation(props.touched)}
                        </div>
                        <div className='row'>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                              <Input
                                id="convenzioneBancaria_codiceFiscale"
                                name="convenzioneBancaria_codiceFiscale"
                                value={props.values.convenzioneBancaria_codiceFiscale}
                                type="text"
                                dimension="lg"
                                label={i18next.t("CODICE_FISCALE_PUBBLICO_UFFICIALE")}
                                error={this.state.errorsCodiceFiscalePU !== undefined || props.errors.convenzioneBancaria_codiceFiscale}
                                inputClass={[]}
                                labelClass={[]}
                                event={{ onChange: props.handleChange }}
                                extraProps={{ maxLength: "16" }}
                              />
                          </div>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                            <Input
                              id="convenzioneBancaria_codiceFiscaleStudio"
                              name="convenzioneBancaria_codiceFiscaleStudio"
                              value={props.values.convenzioneBancaria_codiceFiscaleStudio} 
                              type="text"
                              dimension="lg"
                              label={i18next.t("CODICE_FISCALE_ENTE")}
                              error={this.state.errorsCodiceFiscaleStudio !== undefined || props.errors.convenzioneBancaria_codiceFiscaleStudio}
                              inputClass={[]}
                              labelClass={[]}
                              event={{ onChange: props.handleChange }}
                              extraProps={{ maxLength: "11"  }}
                            />
                          </div>
                          <div className='col-sm-12 col-md-4 col-xl-4'>
                            <Input
                              id="convenzioneBancaria_codiceIBAN"
                              name="convenzioneBancaria_codiceIBAN"
                              value={props.values.convenzioneBancaria_codiceIBAN}
                              type="text"
                              dimension="lg"
                              label={i18next.t("CODICE_IBAN")}
                              error={this.state.errorsCodiceIBAN !== undefined || props.errors.convenzioneBancaria_codiceIBAN}
                              inputClass={[]}
                              labelClass={[]}
                              event={{ onChange: props.handleChange }}
                              extraProps={{ maxLength: "27" }}
                            />
                          </div>
                        </div>
                        <div className='row'>
                          <div className='col-sm-12 col-md-12 col-xl-12 text-center'>
                            {props.values.convenzioneBancaria_editIndex === undefined && (<AppButton titleKey="BUTTON_AGGIUNGI_CONVENZIONE_BANCARIA" iconLeft="fas fa-plus" color="green" onClick={() => this.onClickAggiungiConvenzioneBancaria(props)} />)}
                            {props.values.convenzioneBancaria_editIndex !== undefined && (
                              <>
                                <AppButton titleKey="BUTTON_SALVA_CONVENZIONE_BANCARIA" iconLeft="fas fa-save" customClass="mr-2" color="green" onClick={() => this.onClickAggiungiConvenzioneBancaria(props)} />
                                <AppButton titleKey="BUTTON_ANNULLA" color="red" onClick={() => this.onClickAnnullaModificaConvenzioneBancaria(props)} />
                              </>
                            )}
                          </div>
                        </div>
                        <div className='row'>
                            <div className='col'>
                                <Table
                                    tableHead={tableHead}
                                    tableBody={tableBody(props)}
                                    tableOptions={['table-header']}
                                    extraClass={['pt-3']}
                                >
                                    {" "}
                                </Table>
                            </div>
                        </div>
                        
                      <div className='row pt-3'>
                          <div className='col'>
                            <AppButton titleKey="COMPILA" type="button" iconLeft="fas fa-pen" customClass="mr-2" 
                              onClick={() => {
                                scrollToTop();
                                this.setState({downloadPagamentoIntegrativoEffettuato:false})
                                props.handleSubmit();
                              }}
                            />
                            <AppButton titleKey="BUTTON_RIPULISCI" color="outlined-blu" type="button" iconLeft="fas fa-eraser" onClick={() =>this.clean(props)}/>
                          </div>
                      </div>
                    </form>
                  </>
                )}
            </Formik>

          </div>
        ); 
      }


}


export default DatiUtente

export { DatiUtente }

